import { render, staticRenderFns } from "./InventoryFormModal.vue?vue&type=template&id=44096870"
import script from "./InventoryFormModal.vue?vue&type=script&lang=js"
export * from "./InventoryFormModal.vue?vue&type=script&lang=js"
import style0 from "./InventoryFormModal.vue?vue&type=style&index=0&id=44096870&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports